'use client';

import { c as _c } from "react/compiler-runtime";
import { filterBuilderAttributes } from '@src/utils/builder.util';
import { cn } from '@src/utils/tailwind';
import { textStyleMap } from '../Builder/Text/Text';
import { type IconNames, IconText, type IconTypes } from '../IconText/IconText';
interface ChecklistProps {
  items?: Array<{
    value?: string;
  }>;
  checkColor?: string;
  checkIcon?: (typeof IconNames)[number];
  iconType?: (typeof IconTypes)[number];
  iconSize?: number;
  textStyle?: keyof typeof textStyleMap;
  separation?: number;
  attributes?: any;
}
export const Checklist = props => {
  const $ = _c(26);
  const {
    items: t0,
    checkColor: t1,
    checkIcon: t2,
    iconType: t3,
    iconSize: t4,
    textStyle: t5,
    separation: t6,
    attributes
  } = props;
  let t7;
  if ($[0] !== t0) {
    t7 = t0 === undefined ? [] : t0;
    $[0] = t0;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  const items = t7;
  const checkColor = t1 === undefined ? "#825BB5" : t1;
  const checkIcon = t2 === undefined ? "CheckIcon" : t2;
  const iconType = t3 === undefined ? "solid" : t3;
  const iconSize = t4 === undefined ? 16 : t4;
  const textStyle = t5 === undefined ? "Body MD" : t5;
  const separation = t6 === undefined ? 8 : t6;
  if (!items) {
    return null;
  }
  let t8;
  if ($[2] !== attributes) {
    t8 = filterBuilderAttributes(attributes);
    $[2] = attributes;
    $[3] = t8;
  } else {
    t8 = $[3];
  }
  const t9 = attributes?.className;
  let t10;
  if ($[4] !== t9) {
    t10 = cn("flex w-full flex-col", t9);
    $[4] = t9;
    $[5] = t10;
  } else {
    t10 = $[5];
  }
  let t11;
  if ($[6] !== separation) {
    t11 = {
      gap: separation
    };
    $[6] = separation;
    $[7] = t11;
  } else {
    t11 = $[7];
  }
  let t12;
  if ($[8] !== checkColor || $[9] !== checkIcon || $[10] !== iconSize || $[11] !== iconType || $[12] !== items || $[13] !== textStyle) {
    let t13;
    if ($[15] !== checkColor || $[16] !== checkIcon || $[17] !== iconSize || $[18] !== iconType || $[19] !== textStyle) {
      t13 = (t14, i) => {
        const {
          value
        } = t14;
        return <IconText iconColor={checkColor} iconName={checkIcon} iconType={iconType} iconSize={iconSize} key={`${value}${i}`}><span className={cn("w-fit", textStyleMap[textStyle])} dangerouslySetInnerHTML={{
            __html: value ?? ""
          }} /></IconText>;
      };
      $[15] = checkColor;
      $[16] = checkIcon;
      $[17] = iconSize;
      $[18] = iconType;
      $[19] = textStyle;
      $[20] = t13;
    } else {
      t13 = $[20];
    }
    t12 = items.map(t13);
    $[8] = checkColor;
    $[9] = checkIcon;
    $[10] = iconSize;
    $[11] = iconType;
    $[12] = items;
    $[13] = textStyle;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[21] !== t10 || $[22] !== t11 || $[23] !== t12 || $[24] !== t8) {
    t13 = <div {...t8} className={t10} style={t11}>{t12}</div>;
    $[21] = t10;
    $[22] = t11;
    $[23] = t12;
    $[24] = t8;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  return t13;
};